var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRead = function SvgRead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6.25V4.05C14.75 2.89489 14.75 2.31734 14.5211 1.87614C14.3198 1.48806 13.9985 1.17254 13.6034 0.974799C13.1542 0.75 12.5661 0.75 11.39 0.75H4.11C2.93389 0.75 2.34583 0.75 1.89662 0.974799C1.50148 1.17254 1.18022 1.48806 0.978886 1.87614C0.75 2.31734 0.75 2.89489 0.75 4.05V8.45C0.75 9.60511 0.75 10.1827 0.978886 10.6239C1.18022 11.0119 1.50148 11.3275 1.89662 11.5252C2.34583 11.75 2.93389 11.75 4.11 11.75H5.75M0.75 2.8125L6.46544 6.74187C6.92826 7.06006 7.15967 7.21915 7.41138 7.28077C7.63373 7.33521 7.86627 7.33521 8.08861 7.28077C8.34033 7.21915 8.57174 7.06006 9.03456 6.74187L14.75 2.8125",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.9722L10.25 12.75L14.75 8.75",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/read.417ec98c.svg";
export { ForwardRef as ReactComponent };